import {
  http,
  http3,
  httpFromgrab,
  httpFromPromo,
  httpFromReplika,
  httpAssignSurveyor,
} from "@/plugins/api";
// import { httpOrderIn2 } from '@/plugins/api'
// import { httpOrderMS2 } from '@/plugins/api'
import { httpWithoutBearer } from "@/plugins/api";
import {
  TOKEN_POST_GRAB,
  TOKEN_FLASHDEAL,
  TOKEN_POST_GRAB_UAT,
  TOKEN_ASSIGN_SUERVEYOR,
} from "@/stores/constants";
import { token } from "@/services/token";
import { decryptResponse } from '@/helpers/responseEncryption'

import store from "@/stores/store";
import { http6, httpSimulasi } from "../plugins/api";

const { accessToken } = token;

const AUTH_POST_GRAB =
  process.env.NODE_ENV === "production" ? TOKEN_POST_GRAB : TOKEN_POST_GRAB_UAT;

export const submitOrderRequest = (payload = {}) => {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${accessToken}`,
  };
  const url = "/transaction/transactions";

  // ================================
  // GENERATE CURL FORM-Data : uncomment if you need to debug. Comment if its on release code
  // ================================
  // if (payload instanceof FormData) {
  //   let curl = `curl --location --request POST '${http.defaults.baseURL}${url}' \\\n`;

  //   payload.forEach((value, key) => {
  //     // kosongkan base64 besar
  //     if (key === "ktp_image" || key === "bpkb") {
  //       curl += `--form '${key}=' \\\n`;
  //     } else {
  //       curl += `--form '${key}=${value}' \\\n`;
  //     }
  //   });

  //   console.log("===== GENERATED CURL (MULTIPART FORM-DATA) =====");
  //   console.log(curl);
  // }
  // ================================

  return http.post(url, payload, {
    headers,
  });
};

export const submitOrderFromGrabRequest = (payload = {}) => {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${accessToken}`,
  };
  const url = "/transaction/transactions";
  return httpFromgrab.post(url, payload, {
    headers,
  });
};

export const submitOrderFromPromoRequest = (payload, token) => {
  // console.log(payload, token);
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${token}`,
  };
  const url = "/transaction/transactions";
  return httpFromPromo.post(url, payload, {
    headers,
  });
};
export const submitOrderFromReplikaRequest = (payload = {}) => {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Bearer ${AUTH_POST_GRAB}`,
  };
  const url = "/transaction/transactions";
  return httpFromReplika.post(url, payload, {
    headers,
  });
};
export const submitOrderMS2 = (payload = {}) => {
  const headers = {
    "Content-Type": "application/json",
  };

  // const url = '/transaction/transactions'
  // return http.post(url, payload, {
  //   headers
  // })
  // console.log("submitOrderMS2")
  // console.log(payload)
  const url = "/orderin/ms2Request";
  // const url = '/6JbZ1VqDMGiP7BZ6nwEa'
  return httpWithoutBearer.post(url, payload, {
    headers,
  });
};

export const createProfile = (payload = {}) => {
  const url = "/profile/profiles/order-in";
  // return http.post(url, payload);
  return http.post(url, payload).then((response) => {
    return decryptResponse(response, token.accessToken);
  });
};

export const checkAxiId = (id) => {
  const url = "/profile/detail-axis/search";
  const params = {
    nomor_axi_id: id,
  };

  return http3.get(url, {
    params
  }).then((response) => {
    return decryptResponse(response, token.accessToken);
  });
};

export const checkVehicleNumber = (id) => {
  const url = "/transaction/transactions/search/check-vehicle-id";
  const params = {
    vehicle_id: id,
  };

  return http.get(url, {
    params,
  });
};

export const checkVoucher = (id) => {
  const url = "/transaction/voucher-codes/search/code";
  const params = {
    code: id,
  };

  return http.get(url, {
    params,
  });
};

export const getPekerjaan = () => {
  const url = "/orderin/jobs";

  return httpWithoutBearer.get(url);
};

export const getJenisKendaraan = (id) => {
  const url = `/orderin/vehicles/${id}`;

  return httpWithoutBearer.get(url);
};

export const getJenisPembiayaan = () => {
  const url = "/orderin/pembiayaan";

  return httpWithoutBearer.get(url);
};

export const getJenisProduct = () => {
  const url = "/orderin/products";

  return httpWithoutBearer.get(url);
};

export const getJenisKegiatanUsaha = () => {
  const url = "/orderin/jenisUsaha";

  return httpWithoutBearer.get(url);
};

export const getListCro = (branch_id) => {
  const url = `/orderin/listCro/${branch_id}`;

  return httpWithoutBearer.get(url);
};

export const getTransaksi = (id) => {
  const headers = {
    Accept: "application/vnd.api+json",
    Authorization: `Bearer ${AUTH_POST_GRAB}`,
    // "Authorization": `Bearer ${token}`
  };
  const params = {
    include:
      "branch,area,current_pic.addresses,prospective_customer.addresses,agent.addresses,sub_product,product,object_brand,object_model,collateral,voucher-code,insurance_type,agent.detail-axis",
  };
  const url = `transaction-composer/transactions/${id}`;

  return httpAssignSurveyor.get(url, {
    headers,
    params,
  });
};
export const getUpdatedTransaksi = (id) => {
  const headers = {
    Accept: "application/vnd.api+json",
    // "Authorization": `Bearer ${token}`
  };
  const url = `orderin/telecenter/${id}`;

  return httpWithoutBearer.get(url);
};
export const getTransaksiPayload = (id) => {
  const headers = {
    Accept: "application/vnd.api+json",
    Authorization: `Bearer ${AUTH_POST_GRAB}`,
  };
  const url = `transaction/transactions/${id}`;

  return httpAssignSurveyor.get(url, {
    headers,
  });
};
export const updateTransaksi = (payload = {}, id) => {
  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${AUTH_POST_GRAB}`,
  };
  const url = `/transaction/transactions/${id}`;
  return httpWithoutBearer.post(url, payload, {
    headers,
  });
};
export const updateTelecenter = (payload = {}, id) => {
  const headers = {
    "Content-Type": "application/json",
  };
  // console.log(payload)
  const url = `/orderin/telecenter/surveyStatus/${id}`;
  // const url = `/telecenter/surveyStatus/${id}`
  return httpWithoutBearer.patch(url, payload, {
    headers,
  });
};
export const checkAgentCode = (payload) => {
  const url = "/transaction/transactions/partnership/check-agent-code";
  const params = {
    agent_code: payload?.id,
    partner_code: payload?.partner,
  };

  return http.get(url, {
    params,
  });
};
export const checkTodayOrder = (payload = {}) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${payload.token}`,
  };
  const url = "/transaction/transactions/check-limit-pengajuan";
  return httpFromgrab.post(url, payload, {
    headers,
  });
};

// START NEW API

export const getJenisJaminan = () => {
  const url = `/credit-simulation-v2/param-unit-genre`;
  return httpSimulasi.post(
    url,
    {},
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
};

export const getDaftarCabang = (payload) => {
  const params = {
    kode_object_grup: payload.kode_object_grup,
    kelurahan_id: payload.kelurahan_id,
    zipcode: payload.zipcode,
    nomor_axi_id: payload.nomor_axi_id,
  };

  const url = `/branch-office/commonapi/getBranchMap`;

  return httpWithoutBearer.post(url, params);
};

export const getParamArea = () => {
  const url = `/branch-office/commonapi/getParamArea`;

  return httpWithoutBearer.post(url);
};

export const getBranchArea = (payload) => {
  const url = `/branch-office/commonapi/getParamBranchByAreaId`;

  const params = {
    areaId: payload.areaId,
    objGroupId: payload.objGroupId,
  };

  return httpWithoutBearer.post(url, params);
};

export const getParamBrandTypeModel = (payload) => {
  const url = `/branch-office/commonapi/getParamBrandTypeModel`;

  const params = {
    objGroupId: payload.objGroupId,
    objGenreId: payload.objGenreId,
    objBrandId: payload.objBrandId,
  };

  return httpWithoutBearer.post(url, params);
};

export const getParamBrandByObjectGroupId = (payload) => {
  const url = `/branch-office/commonapi/getParamBrandByObjectGroupId`;

  const params = {
    objectGroupId: payload.objectGroupId,
  };

  return httpWithoutBearer.post(url, params);
};

export const getParamMrp = (payload) => {
  const url = `/commonapi/getParamMrp`;

  const params = {
    sentraId: payload.sentraId,
    objGroupId: payload.objGroupId,
    objId: payload.objId,
    objBrandId: payload.objBrandId,
    objTypeId: payload.objTypeId,
    objModelId: payload.objModelId,
    purposeId: payload.purposeId,
  };

  return httpSimulasi.post(url, params);
};

export const getAlamatKelurahan = (keyword) => {
  const url = `/area/map-alamat-sap?kelurahan=${keyword}`;

  return httpWithoutBearer.get(url, keyword);
};

export const submitOrder = (payload, token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const url = `/transaction/transactions/submitOrder`;

  return httpFromgrab.post(url, payload, {
    headers,
  });
};

export const simulation = (payload) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const url = `/credit-simulation-v2/calculate-simulation`;

  return httpSimulasi.post(url, payload, {
    headers,
  });
};

export const detailAxi = (axiId) => {
  const url = `/profile/detail-axis/search?nomor_axi_id=${axiId}`;

  return httpWithoutBearer.get(url, axiId);
};

export const processIcrKtp = (payload) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const url = "/process-icr-ktp";

  return http6.post(url, payload, {
    headers,
  });
};
